<template>
  <q-card>
    <q-card-section>
      <slot name="header">
        <div
          v-if="title"
          class="text-h6"
        >
          {{ title }}
        </div>
      </slot>
      <slot />
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: 'LwfCard',
  props: {
    title: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style scoped>

</style>
